
import { createClient, SupportedStorage } from '@supabase/supabase-js';

/**
 * PROTEÇÃO DE SESSÃO V4 - VAULT LOCAL ENCRIPTADO
 * Resolve o problema de loop e esconde os dados de curiosos.
 */
const VAULT_SECRET = "eq_soberana_v4_vault_key";

// Funções robustas de criptografia para strings longas (JSON de sessão)
const vaultEncrypt = (text: string): string => {
  const textBytes = new TextEncoder().encode(text);
  const saltBytes = new TextEncoder().encode(VAULT_SECRET);
  const result = new Uint8Array(textBytes.length);
  for (let i = 0; i < textBytes.length; i++) {
    result[i] = textBytes[i] ^ saltBytes[i % saltBytes.length];
  }
  // Conversão segura byte-a-byte para evitar estouro de pilha (RangeError)
  let binary = '';
  const len = result.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(result[i]);
  }
  return btoa(binary);
};

const vaultDecrypt = (encoded: string): string => {
  try {
    const binary = atob(encoded);
    const saltBytes = new TextEncoder().encode(VAULT_SECRET);
    const result = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
      result[i] = binary.charCodeAt(i) ^ saltBytes[i % saltBytes.length];
    }
    return new TextDecoder().decode(result);
  } catch (e) {
    return "";
  }
};

const encryptedStorage: SupportedStorage = {
  getItem: (key: string): string | null => {
    const data = localStorage.getItem(key);
    if (!data) return null;
    const decrypted = vaultDecrypt(data);
    return decrypted || null;
  },
  setItem: (key: string, value: string): void => {
    const encrypted = vaultEncrypt(value);
    localStorage.setItem(key, encrypted);
  },
  removeItem: (key: string): void => {
    localStorage.removeItem(key);
  },
};

const metaEnv = (import.meta as any).env || {};
const supabaseUrl = metaEnv.VITE_SUPABASE_URL || '';
const supabaseAnonKey = metaEnv.VITE_SUPABASE_ANON_KEY || '';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    storage: encryptedStorage,
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storageKey: 'eq-session-blob' // Nome genérico para não atrair atenção
  }
});
